import { render } from "./CustomerBookingVersionHistory.vue?vue&type=template&id=48b7f5a3&ts=true&lang=pug"
import script from "./CustomerBookingVersionHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerBookingVersionHistory.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__